import { render, staticRenderFns } from "./CommentUserRecursive.vue?vue&type=template&id=0f975a3d&scoped=true&"
import script from "./CommentUserRecursive.vue?vue&type=script&lang=ts&"
export * from "./CommentUserRecursive.vue?vue&type=script&lang=ts&"
import style0 from "./CommentUserRecursive.vue?vue&type=style&index=0&id=0f975a3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f975a3d",
  null
  
)

export default component.exports